/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
const areIntlLocalesSupported = require('./lib')['default']
module.exports = areIntlLocalesSupported;
module.exports.default = areIntlLocalesSupported;